import { MapEngine } from "../map/core/MapEngine";

export class MessageRouter {
  private mapEngine: MapEngine;

  constructor() {
    this.mapEngine = MapEngine.getInstance();
  }

  async route(message: any) {
    // Handle topic-based messages
    if (message.topic && message.payload) {
      await this.mapEngine.handleWebSocketMessage(
        message.topic,
        message.payload,
      );
      return;
    }

    // Handle other message types
    if (message.type === "pong") {
      // Handle heartbeat
      return;
    }

    console.warn("[MessageRouter] Unhandled message:", message);
  }
}
